import cancelOption from '../actions/cancelOption';
import { getOptionsStore } from '../store/Store';
import { mutator } from 'satcheljs';
// We are not using a mutatorAction since it does not log any datapoint - https://outlookweb.visualstudio.com/Outlook%20Web/_wiki/wikis/Outlook%20Web.wiki?pagePath=%2FClient%2FArchitecture%2FAnalytics&wikiVersion=GBwikiMaster
// not a public interface and hence function doc not needed here
const cancelOptionMutator = mutator(cancelOption, (actionMessage: {}) => {
    const store = getOptionsStore();
    store && (store.activeViewState = null);
});

// exported only for testing purposes
export default cancelOptionMutator;
